export const getRoofName = (item, alias) => {
  const roofName =
    !item.Value.includes("ROOF_TIN") && !item.Value.includes("ROOF_SANDWICH")
      ? alias.bfcKanalplast + " "
      : "";

  let roofValue;

  if (item.Value.includes("ROOF_TIN")) {
    switch (item.Value) {
      case "ROOF_TIN":
        roofValue = alias.bfcRoofTinSilver;
        break;
      case "ROOF_TIN_BLACK":
        roofValue = alias.bfcRoofTinBlack;
        break;
      case "ROOF_TIN_RED":
        roofValue = alias.bfcRoofTinRed;
        break;
      default:
        break;
    }
  } else if (item.Value.includes("ROOF_SANDWICH")) {
    switch (item.Value) {
      case "ROOF_SANDWICH_SILVER":
        roofValue = alias.bfcRoofSandwichSilver;
        break;
      case "ROOF_SANDWICH_BLACK":
        roofValue = alias.bfcRoofSandwichBlack;
        break;
      case "ROOF_SANDWICH_RED":
        roofValue = alias.bfcRoofSandwichRed;
        break;
      default:
        break;
    }
  } else {
    roofValue = `${item.Value.replace("ROOF_", "")} mm`;
  }

  if (roofValue && roofValue.includes("_IR")) {
    roofValue = `${roofValue.replace("_IR", "")} comfort`;
  }

  return roofName + roofValue;
};
